// @flow
export const PASSWORD_INPUT_THEME_API = {
  root: '',
  tooltip: '',
  hint: '',
  error: '',
  warning: '',
  success: '',
};
